import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const CodigoGrupoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)

  const [codigosGrupos, setCodigosGrupos] = React.useState([])
  const [mostrarModalCrud, setMostrarModalCrud] = React.useState(false)

  const refreshSelect = React.useCallback(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.GRUPOCAJAMOVIMIENTO)
      .then(({ data }) => setCodigosGrupos(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const onSuccess = React.useCallback(() => {
    refreshSelect()
    setMostrarModalCrud(false)
  }, [refreshSelect])

  React.useEffect(() => {
    refreshSelect()
  }, [refreshSelect])

  return (
    <>
      <Form.Group>
        <Form.Label text='CODIGO GRUPO' htmlFor='select-codigoGrupo' md={3} alignRightAt='md' />
        <Col md={9}>
          <Form.InputGroup>
            <Field name='codigoGrupo'>
              {({ field }) => (
                <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-codigoGrupo'>
                  <option value=''>Seleccionar</option>
                  {codigosGrupos.map((val, key) => (
                    <option key={key} value={val._id}>
                      {val.nombre}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarModalCrud(true)}>+</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModalCrud && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarModalCrud(false)}
          show={mostrarModalCrud}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCAJAMOVIMIENTO}
        />
      )}
    </>
  )
}

export default React.memo(CodigoGrupoFormGroup)
